const CEP_LENGTH = 8;
const PREFIX_LENGTH = 5;

export const normalizeCep = (raw: string): string => raw.replace(/\D/g, '');

export const isValidCep = (raw: string): boolean => {
  const digits = normalizeCep(raw);
  if (digits.length !== CEP_LENGTH) {
    return false;
  }
  // Brazilian CEP prefixes start at 01000. ViaCEP accepts 00000000 as a well
  // formed value, and it would resolve to nothing.
  return digits.slice(0, PREFIX_LENGTH) !== '0'.repeat(PREFIX_LENGTH);
};

export const formatCep = (raw: string): string => {
  const digits = normalizeCep(raw).slice(0, CEP_LENGTH);
  if (digits.length <= PREFIX_LENGTH) {
    return digits;
  }
  return `${digits.slice(0, PREFIX_LENGTH)}-${digits.slice(PREFIX_LENGTH)}`;
};
